import { Component } from '@angular/core';
import { KombiLernformService } from '../../../../services/facetten/instance/lernformen-facetten/kombilernform.service';
import { LernformFacettenService } from '../../../../services/facetten/instance/lernformen-facetten/lernformfacetten.service';
import { UnterrichtsformBasisFacetteComponent } from '../unterrichtsform-basis-facette/unterrichtsform-basis-facette.component';

@Component({
  selector: 'now-wbsuche-lib-kombinierte-lernform-facette',
  templateUrl: './kombinierte-lernform-facette.component.html',
  imports: [UnterrichtsformBasisFacetteComponent],
  providers: [
    // Hier wird der LernformFacettenService injected, welcher dann in der UnterrichtsFormBasisFacette verwendet werden kann
    { provide: LernformFacettenService, useExisting: KombiLernformService }
  ]
})
export class KombinierteLernformFacetteComponent {}
